/**
 * Header Dropdown Hover
 * Opens dropdown menus on hover for better UX
 * Allows parent links to be clickable
 */
(function() {
  'use strict';

  function initHeaderDropdownHover() {
    const dropdownItems = document.querySelectorAll('.pawline-nav__item--has-dropdown');
    
    dropdownItems.forEach(item => {
      const submenu = item.querySelector('.pawline-nav__submenu');
      const caretBtn = item.querySelector('.pawline-nav__caret-btn');
      
      if (!submenu) return;

      let hoverTimeout;
      let isOpen = false;

      function openDropdown() {
        clearTimeout(hoverTimeout);
        if (!isOpen) {
          item.setAttribute('data-dropdown-open', 'true');
          if (caretBtn) {
            caretBtn.setAttribute('aria-expanded', 'true');
          }
          isOpen = true;
        }
      }

      function closeDropdown() {
        hoverTimeout = setTimeout(() => {
          item.removeAttribute('data-dropdown-open');
          if (caretBtn) {
            caretBtn.setAttribute('aria-expanded', 'false');
          }
          isOpen = false;
        }, 150); // Small delay to allow moving to submenu
      }

      // Open on hover
      item.addEventListener('mouseenter', openDropdown);
      item.addEventListener('mouseleave', closeDropdown);
      
      // Keep open when hovering over submenu
      submenu.addEventListener('mouseenter', () => {
        clearTimeout(hoverTimeout);
        openDropdown();
      });
      
      submenu.addEventListener('mouseleave', closeDropdown);

      // Toggle dropdown on caret button click
      if (caretBtn) {
        caretBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (isOpen) {
            closeDropdown();
          } else {
            openDropdown();
          }
        });
      }
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderDropdownHover);
  } else {
    initHeaderDropdownHover();
  }
})();

